// extracted by mini-css-extract-plugin
export default {"download":"ReportDownload_download__y6cyO","is-disabled":"ReportDownload_is-disabled__qLpC7"};